import { createContext } from 'react';

const FavoriteStyleContext = createContext({});

export default FavoriteStyleContext;
